var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSteamRoom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133 35.6724C125.802 30.4886 116.594 30.4886 109.396 35.6724C105.055 38.8535 99.2338 38.7357 94.8942 35.5547C87.6964 30.3708 78.4877 30.3708 71.3957 35.5547C66.9497 38.7357 61.3399 38.7357 57 35.5547",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133 35.6724C125.802 30.4886 116.594 30.4886 109.396 35.6724C105.055 38.8535 99.2338 38.7357 94.8942 35.5547C87.6964 30.3708 78.4877 30.3708 71.3957 35.5547C66.9497 38.7357 61.3399 38.7357 57 35.5547",
    stroke: "url(#paint0_linear_16725_954)",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 59.3859C26.3998 64.5702 35.8671 64.5702 43.2669 59.3859C47.7285 56.2047 53.6048 56.2047 58.0664 59.3859C65.4664 64.5702 75.0424 64.688 82.3333 59.5036",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 59.3859C26.3998 64.5702 35.8671 64.5702 43.2669 59.3859C47.7285 56.2047 53.6048 56.2047 58.0664 59.3859C65.4664 64.5702 75.0424 64.688 82.3333 59.5036",
    stroke: "url(#paint1_linear_16725_954)",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M133 92.6143C125.802 87.4298 116.594 87.4298 109.396 92.6143C105.055 95.7955 99.3396 95.7955 95 92.6143C87.8022 87.4298 78.4877 87.312 71.3957 92.4965C66.9497 95.6777 61.3399 95.6777 57 92.4965",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M133 92.6143C125.802 87.4298 116.594 87.4298 109.396 92.6143C105.055 95.7955 99.3396 95.7955 95 92.6143C87.8022 87.4298 78.4877 87.312 71.3957 92.4965C66.9497 95.6777 61.3399 95.6777 57 92.4965",
    stroke: "url(#paint2_linear_16725_954)",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19 116.386C26.3998 121.57 35.8671 121.57 43.2669 116.386C47.7285 113.204 53.6048 113.204 58.0664 116.386C65.4664 121.57 75.0424 121.688 82.3333 116.503",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19 116.386C26.3998 121.57 35.8671 121.57 43.2669 116.386C47.7285 113.204 53.6048 113.204 58.0664 116.386C65.4664 121.57 75.0424 121.688 82.3333 116.503",
    stroke: "url(#paint3_linear_16725_954)",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16725_954",
    x1: 57,
    y1: 31.6667,
    x2: 64.701,
    y2: 57.9851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16725_954",
    x1: 19,
    y1: 57,
    x2: 27.9317,
    y2: 82.4362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_16725_954",
    x1: 57,
    y1: 88.6665,
    x2: 64.7017,
    y2: 114.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_16725_954",
    x1: 19,
    y1: 114,
    x2: 27.9321,
    y2: 139.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteamRoom);
export default __webpack_public_path__ + "static/media/steam-room.1ce2d512fbd219774c2576df68002725.svg";
export { ForwardRef as ReactComponent };